"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompetitionType = void 0;
var CompetitionType;
(function (CompetitionType) {
    CompetitionType[CompetitionType["None"] = 0] = "None";
    CompetitionType[CompetitionType["SlotGame"] = 1] = "SlotGame";
    CompetitionType[CompetitionType["LiveGame"] = 2] = "LiveGame";
    CompetitionType[CompetitionType["MobileGame"] = 4] = "MobileGame";
    CompetitionType[CompetitionType["TomHornGame"] = 8] = "TomHornGame";
    CompetitionType[CompetitionType["TomhornSlotGame"] = 9] = "TomhornSlotGame";
    CompetitionType[CompetitionType["TomHornSpecialGame"] = 16] = "TomHornSpecialGame";
    CompetitionType[CompetitionType["TomhornSpecialSlotGame"] = 17] = "TomhornSpecialSlotGame";
    CompetitionType[CompetitionType["BoomingGame"] = 32] = "BoomingGame";
    CompetitionType[CompetitionType["BoomingSlotGame"] = 33] = "BoomingSlotGame";
    CompetitionType[CompetitionType["BoomingHdsVariant"] = 64] = "BoomingHdsVariant";
    CompetitionType[CompetitionType["BoomingMobileVariant"] = 128] = "BoomingMobileVariant";
    CompetitionType[CompetitionType["BoomingMobileSlotGame"] = 165] = "BoomingMobileSlotGame";
    CompetitionType[CompetitionType["BoomingHdsMobileSlotGame"] = 229] = "BoomingHdsMobileSlotGame";
    CompetitionType[CompetitionType["GoldenRace"] = 256] = "GoldenRace";
    CompetitionType[CompetitionType["BoaGames"] = 512] = "BoaGames";
    CompetitionType[CompetitionType["RGS"] = 1024] = "RGS";
    CompetitionType[CompetitionType["Xpress"] = 2048] = "Xpress";
    CompetitionType[CompetitionType["Oddin"] = 4096] = "Oddin";
})(CompetitionType = exports.CompetitionType || (exports.CompetitionType = {}));
